import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Autocomplete,
    Checkbox,
    Button
} from '@workboard/wobo-ui';

const WsAvatar = ({
    'aria-selected': ariaSelected,
    ...props
  }) => {
    return (
        <React.Fragment>
            <Checkbox
                label={
                    <div className="autocomplete-item">
                        <div className="user-icon">
                            {props.userPic ? <img src={props.userPic} /> : <span className="icon icon-outline-people-24px"></span>}
                        </div>{props.label}
                    </div>
                }
                isChecked={!!ariaSelected}
                />
        </React.Fragment>

    );
}


const WsShareAddComp = (props: any) => {
    const { t } = useTranslation();
    let memberCount: number = 0; 

    const { value } = props;
    const [autocompleteValue, setAutocompleteValue] = useState([]);

    useEffect(() => {
      setAutocompleteValue(value);
    }, [value])

    if (props.wsAccessList && props.wsAccessList.length > 0) {
        memberCount = props.wsAccessList.filter(item => item.isChecked).length;
    }
    const handleOpen = () => {
        setTimeout(() => { 
            $('#user_team_list-popup').parent().addClass('ws-autocomplete-dropdown');
        }, 300)
    } 

    return (
        <React.Fragment>
            <div className="display-flex share-txt-section">
                <div><p className="share-ws-txt">{t("Share this workstream with")}:</p></div>
                <div>
                    <p className="shared-with-txt">
                        {t("sharing.sharedWithMembers", { count: memberCount })}
                    </p>
                </div>
            </div>

            <div className="display-flex">
                <div className="team-autocomplete">
                    <Autocomplete
                        multiple
                        id="user_team_list"
                        placeholder={t('type a person or team name')}
                        startMatch={false}
                        isDisabled={false}
                        value={autocompleteValue || []}
                        options={props.options ? props.options : []}
                        autoHighlight={false}
                        autoSelect={false}
                        getOptionLabel={(option: any) => option.label ? option.label : "" }
                        getOptionSelected={(option, value) => {
                            if(option && value){
                                return (option && value && (option.value === value.value))
                            }
                        }}
                        onChange={(e, v) => {
                          setAutocompleteValue(v);
                          props.onUpdateWsAccessList(v);
                        }} 
                        onClose={(e, v) => {
                          if (v === 'blur' && autocompleteValue.length === 0) {
                            props.onUpdateWsAccessList([]);
                          }
                        }} 
                        template={WsAvatar} 
                        query={async (term) => {
                          if (term) {
                            return await props.wsSearchPermissionQuery(term)
                          }
                          return []
                          
                        }}
                    />
                    {props.isError.isAddError ? <p className="validation_error">{t("Please enter person or team name")}</p> : ''}
                    {props.isError.isSaveError ? <p className="validation_error">{t("Please select user and click save")}</p> : ''}
                </div>
                <div>
                    <Button
                        id="add_btn_userlist"
                        variant='primary'
                        size="medium"
                        className="ws-add-btn"
                        onClick={props.addAccessHandler}>
                        {t('Add')}</Button>
                </div>
            </div>
        </React.Fragment>
    )
}

export default WsShareAddComp;